<template>
<div class="audioMgt padding-20 bgc box-shadow">
<router-view :param="param"></router-view>

</div>
</template>

<script>
import {mapActions} from 'vuex'
import {initPage} from 'common/js/mixin'
export default {
    name: 'audioMgt',
    mixins: [initPage],
    data() {
        return {
            param: {
                status: '',
                subject: ''
            }
        }
    },
    mounted() {
        this.setParams(this._.cloneDeep(this.param))
    },
    methods: {
        ...mapActions([
            'setParams'
        ])
    },
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.audioMgt {
}
</style>
